<template>
    <div class="thumbnail">
        <div class="content">
            <div class="progress progress-striped active expand">
                <div class="progress-bar"
                     v-bind:style="{width: (file.progress * 100) + '%'}"></div>
            </div>
            <div class="file-name">
                <i class="fa icon fa-{{ file.file.type | mimeIcon }}"></i>
                {{ file.file.name }}
            </div>
        </div>
    </div>
</template>

<style scoped>
    .thumbnail {
        padding: 30px;
        display: flex;
        align-items: center;
    }

    .content {
        width: 100%;
    }

    .file-name {
        text-align: center;
    }
</style>

<script type="text/ecmascript-6">
    export default {
        props: {
            file: {
                required: true
            }
        }
    };
</script>



// WEBPACK FOOTER //
// DocumentUploadBox.vue?6d7ce0b6